import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import { __decorate } from "tslib";
import SettingItem from '@/components/platform/SettingItem.vue';
import GridLayout from '@/components/layout/GridLayout.vue';
import CenterTop from '@/components/layout/CenterTop.vue';
import MainTitle from '@/components/title/MainTitle.vue';
import store from '@/store';
import { SETTING_SPE_UPDATE } from "@/store/actions/configurations";
import { Options, Vue } from 'vue-class-component';
var UpdateSettingsSpe = /*#__PURE__*/function (_Vue) {
  function UpdateSettingsSpe() {
    _classCallCheck(this, UpdateSettingsSpe);
    return _callSuper(this, UpdateSettingsSpe, arguments);
  }
  _inherits(UpdateSettingsSpe, _Vue);
  return _createClass(UpdateSettingsSpe, [{
    key: "settings",
    get: function get() {
      return store.getters.speSettingsData;
    }
  }, {
    key: "changeValueFor",
    value: function changeValueFor(setting) {
      store.dispatch(SETTING_SPE_UPDATE, {
        key: setting.key,
        value: !setting.value
      });
    }
  }]);
}(Vue);
UpdateSettingsSpe = __decorate([Options({
  components: {
    SettingItem: SettingItem,
    GridLayout: GridLayout,
    CenterTop: CenterTop,
    MainTitle: MainTitle
  }
})], UpdateSettingsSpe);
export default UpdateSettingsSpe;